import { ReviewOutcomeSummary } from '@/components/common/ReviewDecision';
import { PENDING_SUBMISSION_STATUS } from '../constants/instituteSubmission.constants';
import type { InstituteSubmissionDetail } from '../types/instituteSubmission.types';
import { InstituteSubmissionReviewActions } from './InstituteSubmissionReviewActions';

interface InstituteSubmissionReviewPanelProps {
  submission: InstituteSubmissionDetail;
}

export function InstituteSubmissionReviewPanel({
  submission,
}: InstituteSubmissionReviewPanelProps) {
  if (submission.status === PENDING_SUBMISSION_STATUS) {
    return <InstituteSubmissionReviewActions submission={submission} />;
  }

  return (
    <ReviewOutcomeSummary
      subject="submission"
      status={submission.status}
      reviewedByName={submission.reviewedByName}
      reviewedAt={submission.reviewedAt}
      reviewerComment={submission.reviewerComment}
    />
  );
}
